<template lang="pug">
  router-link.topic-card.relative.column.card-container(:to='cardLink')
    img.topic-img(:src='topic.imageURL' :alt='topic.name')
    .info.item-1.column
      h4.uppercase.text-normal.bold.m4-bottom-1 {{ topic.name }}
      router-link.text-small.blue.underline(:to='cardLink')
        | {{ $t("topics.seeCollection") }}
</template>

<script>
import { routes } from '../router'

export default {
  props: {
    topic: { type: Object },
    isSubtopic: { type: Boolean }
  },
  computed: {
    subtopicLink() {
      return {
        name: routes.search,
        query: {
          ...this.$route.query,
          subtopicIds: this.topic.id
        }
      }
    },
    topicLink() {
      if (this.topic.subtopics.length === 1 && this.topic.subtopics[0].name === this.topic.name) {
        return {
          name: routes.search,
          query: {
            ...this.$route.query,
            subtopicIds: this.topic.subtopics[0].id
          }
        }
      } else {
        return {
          name: routes.search,
          query: {
            ...this.$route.query,
            topicIds: this.$route.query && this.$route.query.topicIds
              ? [...new Set(...this.$route.query.topicIds, this.topic.id)]
              : [this.topic.id]
          }
        }
      }
    },
    cardLink() {
      return this.isSubtopic ? this.subtopicLink : this.topicLink
    }
  }
}
</script>

<style lang="scss" scoped>

.topic-card{
  margin: 0;
  height: 220px;
  border-radius: 8px;
  overflow: hidden;
  .info{
    padding: 14px;
  }
  .topic-img{
    width: 100%;
    height: 130px;
    object-fit: cover;
  }
}
</style>
